import { Toast } from 'mint-ui';
import dayjs from 'dayjs';
import { pushIframe, push, isApp, isIos, pure, clientVersion } from 'atour-jsbridge';
import { compareVersion } from 'atour-utils';
import getQueryVal from '@/utils/getQueryVal';
import { PAGE } from '@/utils/jsBridgeEventName';
import qs from 'qs';
import { encode, decode } from 'js-base64';
import JSEncrypt from 'jsencrypt';
import Store from '@/store';
import CONFIG from '@/config';
import ajax from '@/api';
let initStaus = false;

// 验证码|每日签到，对接极验测试和线上环境Id
const geetestCaptchaId = {
    verify: {
        test: '6a91d4e1c81dfa93953125be7d5d6de5',
        prod: '1461c6af6d31942bae54833e928fb5db',
    },
    sign: {
        test: '6143b28821d03c7f774dafe66b4fcb0d',
        prod: '051dd44e2973389d1d3a0755bd70d757',
    },
};
/**
 *
 * @param {date} date Date对象
 * @param {string} fmt 需要格式化的对象
 */
export function dateFormat(date, fmt) {
    if (!date) {
        return '';
    }
    let fmtInside = fmt;
    if (!fmt) {
        fmtInside = 'YYYY-MM-DD';
    }
    return dayjs(date).format(fmtInside);
}
/**
 * 设置session
 * @param {string} name 需要设置的name
 * @param {any} params 参数
 */
export function setSStorage(name, params) {
    let data = params;
    // 如果是对象则stringfy
    if (typeof data === 'object') {
        data = JSON.stringify(params);
    }
    window.sessionStorage.setItem(name, data);
}
/**
 * 清空token
 */
export function removeInvilidToken() {
    window.localStorage.removeItem('token');
    window.sessionStorage.removeItem('token');

    window.localStorage.removeItem('iSetToken');
    window.sessionStorage.removeItem('iSetToken');

    window.localStorage.removeItem('setToken');
    window.sessionStorage.removeItem('setToken');
}
/**
 * 获取session
 * @param {string} name 需要取的值
 */
export function getSStorage(name) {
    const storage = window.sessionStorage.getItem(name) || window.localStorage.getItem(name);
    let data = storage || '';
    if (!data || data === 'undefined' || data === '') {
        return '';
    }
    try {
        data = JSON.parse(data);
    } catch (err) {
        console.log();
    }
    // eslint-disable-next-line
    return data
}
/**
 * 设置localStorage
 */
export function setLStorage(name, params) {
    let data = params;
    // 如果是对象则stringfy
    if (typeof data === 'object') {
        data = JSON.stringify(params);
    }
    window.localStorage.setItem(name, data);
}
/**
 * 获取localsession
 * @param {string} name 取值名
 */
export function getLStorage(name) {
    let data = window.localStorage.getItem(name) || '';
    if (!data || data === 'undefined' || data === '') {
        return '';
    }
    try {
        data = JSON.parse(data);
    } catch (err) {
        console.log();
    }
    // eslint-disable-next-line
    return data
}
/**
 * 获取用户浏览器信息
 */
export function getUserAgent(name) {
    return window.navigator.userAgent.toLowerCase().indexOf(name) !== -1;
}
/**
 * 判断是否时iphoneX、iphoneXR、iphoneXMax
 */
export function isIphoneX() {
    // eslint-disable-next-line
    const iphoneX = /iphone/gi.test(window.navigator.userAgent) && (+window.screen.height === 812 &&
        +window.screen.width === 375);
    const iphoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio &&
        window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
    const iphoneXsMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio &&
        window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
    if (iphoneX || iphoneXR || iphoneXsMax) {
        return true;
    }
    return false;
}
/**
 * 判断上方padding
 */
export function PaddingTop() {
    // 如果是iphone
    if (getUserAgent('iphone')) {
        // iphonex
        if (isIphoneX()) {
            return '44px';
        }
        // 普通iphone
        return '';
    }
    // 安卓
    return '22px';
}

// 判断版本是否大于等于传入版本
export function isHighAppVersion(version) {
    console.log('app version=============', clientVersion);
    if (!clientVersion) {
        return true;
    }
    // 主版本号[MAJOR].次版本号[MINOR].修订号[PATCH]
    const versionSplit = version.split('.');
    const verMajor = parseInt(versionSplit[0], 10);
    const verMinor = parseInt(versionSplit[1], 10);
    const verPatch = parseInt(versionSplit[2], 10);

    const curVerSplit = clientVersion.split('.');
    const curVerMajor = parseInt(curVerSplit[0], 10);
    const curVerMinor = parseInt(curVerSplit[1], 10);
    const curVerPatch = parseInt(curVerSplit[2], 10);
    console.log(version, clientVersion, 'app ver');
    // 主版本号
    if (verMajor < curVerMajor) {
        return true;
    }
    if (verMajor === curVerMajor) {
        // 次版本号
        if (verMinor < curVerMinor) {
            return true;
        }
        if (verMinor === curVerMinor) {
            // 修订号
            if (verPatch <= curVerPatch) {
                return true;
            }
        }
    }
    return false;
}
const validate = (callback) => {
    var result = window.captchaObj.getValidate();
    console.log('result======', result);
    if (!result) {
        alert('请先完成验证！');
        return;
    }
    Store.commit('setVerifyInfo', result);
    callback(result);
};
export const onShowCaptcha = (cb) => {
    if (window.captchaObj) {
        console.log('++++++成功', window.captchaObj.showCaptcha);
        window.captchaObj.showCaptcha();
    } else {
        Store.commit('setVerifyInfo', { lackType: 'netError' });
        cb?.();
        return false;
    }
};

/**
 * GEETEST 接入配置, 初始化GEETEST
 * @param {*} callback
 * @param {*} type: verify-验证码、sign-每日签到
 */
export const initGeetest4 = (callback, type = 'verify') => {
    console.log(CONFIG.ENV, CONFIG);

    let captchaId = geetestCaptchaId[type]['test'];
    if (['production', 'pre'].includes(CONFIG.ENV)) {
        captchaId = geetestCaptchaId[type]['prod'];
    }
    window.initGeetest4 && window.initGeetest4({
        product: 'bind',
        captchaId,
        hideSuccess: true,
    }, (captchaObj) => {
        window.captchaObj = captchaObj;
        console.log('window.captchaObj====', captchaObj);
        captchaObj
            .appendTo('#captcha')
            .onReady(() => {
                console.log('ready');
            })
            .onNextReady((ready) => {
                console.log('nextReady', ready);
            })
            .onBoxShow((e) => {
                console.log('boxShow', e);
            })
            .onError(function(e) {
                console.log(22, e);
            })
            .onSuccess((res) => {
                console.log('captchaObj onSuccess====>>>', res, window.captchaObj);
                validate(callback);
                captchaObj.reset();
            });
    });
};

/**
 * @description: 加载极验sdk
 * @param {*} callback
 * @param {*} type: verify-验证码、sign-每日签到
 * @param {*} options
 * - onSuccessCallback SDK 加载成功
 * - onErrorCallback SDK 加载失败
 */
export const loadScript = (callback, type = 'verify', options = {}) => {
    // url是按需加载的js文件
    // callback是按需加载的js文件中某个函数
    var script = document.createElement('script');
    // 监听script的下载的状态 当状态变为下载完成后 再执行callback
    script.onload = function() {
        options?.onSuccessCallback?.();
        initGeetest4(callback, type);
    };

    script.onerror = function() {
        options?.onErrorCallback?.();
    };

    // 2. 给script标签添加src 引入一个js文件
    script.src = 'https://static.geetest.com/v4/gt4.js';
    // 3. 追加到body
    document.body.appendChild(script);
};
export const getAppVer = () => {
    // 如果在app中则取ua中的版本号
    if (isApp()) {
        const ua = window.navigator.userAgent.toLocaleLowerCase();
        const version = ua.match(/atourbrowser-atourlife\/([.\d]+)/)[1];
        return version;
    }
    if (getQueryVal('version')) { // 如果URL中携带版本号则使用url上的版本
        return getQueryVal('version');
    }
    // 最后选择本地的版本
    return getLStorage('version') || getSStorage('version');
};

export const isHighOrEqualVersion = (version) => {
    const currentVersion = getAppVer();
    console.log('currentVersion', currentVersion);
    return currentVersion === version || compareVersion(currentVersion, version);
};

// 判断是否是在小程序中
export function judgeMiniApp() {
    return new Promise((resolve, reject) => {
        const ua = navigator.userAgent.toLowerCase();
        console.log(ua);
        // 嵌入的微信sdk，支付宝sdk 只有在小程序下
        if (ua.indexOf('micromessenger') > -1) {
            if (window.wx) {
                wx.miniProgram.getEnv((res) => {
                    if (res.miniprogram) {
                        console.log('微信小程序');
                        resolve({
                            body: wx,
                            type: 'wechat',
                        });
                    } else {
                        console.log('不在微信小程序');
                        // 判断是否在微信浏览器
                        reject('wechat');
                    }
                });
            } else {
                console.log('重新加载wxSDK');
                const script = document.createElement('script');
                script.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js';
                script.onload = () => {
                    wx.miniProgram.getEnv((res) => {
                        if (res.miniprogram) {
                            console.log('微信小程序');
                            resolve({
                                body: wx,
                                type: 'wechat',
                            });
                        } else {
                            console.log('不在微信小程序');
                            reject('wechat');
                        }
                    });
                };
                document.body.appendChild(script);
            }
        } else if (ua.indexOf('alipayclient') > -1) {
            if (window.my) {
                my.getEnv((res) => {
                    if (res.miniprogram) {
                        console.log('支付宝小程序');
                        resolve({
                            body: my,
                            type: 'alipay',
                        });
                    } else {
                        console.log('不在支付宝小程序');
                        reject();
                    }
                });
            } else {
                console.log('重新加载aliSDK');
                const script = document.createElement('script');
                script.src = 'https://appx/web-view.min.js';
                script.onload = () => {
                    my.getEnv((res) => {
                        if (res.miniprogram) {
                            console.log('支付宝小程序');
                            resolve({
                                body: my,
                                type: 'alipay',
                            });
                        } else {
                            console.log('不在支付宝小程序');
                            reject();
                        }
                    });
                };
                document.body.appendChild(script);
            }
        } else if (ua.indexOf('toutiaomicroapp') > -1 || ua.indexOf('toutiaodevtools') > -1) { // 头条小程序
            if (tt) {
                resolve({
                    body: tt,
                    type: 'tt',
                });
            } else {
                console.log('重新加载ttSDK');
                const script = document.createElement('script');
                script.src = 'https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js';
                script.onload = () => {
                    resolve({
                        body: tt,
                        type: 'tt',
                    });
                };
                document.body.appendChild(script);
            }
        } else if (ua.indexOf('xhsminiweb') > -1) { // 小红书H5
            console.log('小红书环境', window.XHSOpenSDK);
            if (window.XHSOpenSDK) {
                if (initStaus) {
                    resolve({
                        body: window.XHSOpenSDK,
                        type: 'xiaoHongShu',
                    });
                } else {
                    console.log('小红书init-start');
                    window.XHSOpenSDK.bridge.init('87ec9961ceecdcddffb672538d773d33').then(() => {
                        console.log('小红书init-success');
                        initStaus = true;
                        resolve({
                            body: window.XHSOpenSDK,
                            type: 'xiaoHongShu',
                        });
                    }).catch((err) => {
                        reject('xiaoHongShu', err);
                    });
                }
            } else {
                console.log('重新加载xhsSDK112');
                const script = document.createElement('script');
                script.src = 'https://s.xiaohongshu.com/formula-static/@xhs/xhs-open-sdk@1.1.0/dist/xhs-open-sdk.min.js';
                script.onload = () => {
                    console.log('小红书onload', initStaus);
                    if (initStaus) {
                        resolve({
                            body: window.XHSOpenSDK,
                            type: 'xiaoHongShu',
                        });
                    } else {
                        console.log('小红书init-start');
                        window.XHSOpenSDK.bridge.init('87ec9961ceecdcddffb672538d773d33').then(() => {
                            console.log('小红书init-success');
                            initStaus = true;
                            resolve({
                                body: window.XHSOpenSDK,
                                type: 'xiaoHongShu',
                            });
                        }).catch((err) => {
                            reject('xiaoHongShu', err);
                        });
                    }
                };
                document.body.appendChild(script);
            }
        } else {
            console.log('不在小程序');
            if (isApp()) {
                reject('app');
            } else {
                reject('H5');
            }
        }
    });
}

// 登录成功后settoken
export function setToken(token) {
    // 存储至vuex
    Store.commit('setToken', token);
    // 存储至local
    // setSStorage('token', token);
    // 'localStorage'、'sessionStorage'都存储
    replaceToken(token);
}

// 生成guid
export function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        // eslint-disable-next-line
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line
        var v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16);
    });
}
// 防抖(立即执行)
export function debounce(fn, wait = 1500) {
    let timerId = null;
    let flag = true;
    return function() {
        clearTimeout(timerId);
        if (flag) {
            fn.apply(this, arguments);
            flag = false;
        }
        timerId = setTimeout(() => { flag = true; }, wait);
    };
}

// 防抖新，上面部分逻辑不太符合要求，故重新封装一个方法
export function debounceNew(func, wait) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            func.apply(context, args);
        }, wait);
    };
}

export function getUrlQueryObj(url = '', params = {}) {
    const splitUrl = url.split('?');
    // 如果原链接没有携带参数则为空，否则为参数对象
    const data = splitUrl.length === 2 ? getUrlParams(url, true) : {};
    const defaultData = {
        ...data,
        ...params,
    };
    const arr = Object.entries(defaultData);
    arr.map(item => {
        if (item[1] === '') {
            delete defaultData[item[0]];
        }
        return item;
    });
    return `${splitUrl[0]}?${qs.stringify(defaultData)}`;
}
export function getUrlParams(url, decode = true) {
    const obj = {};
    const search = decode ? decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ') : url.split('?')[1];
    if (!search) {
        return obj;
    }
    const searchArr = search.split('&');
    searchArr.forEach(v => {
        const index = v.indexOf('=');
        if (index !== -1) {
            const name = v.substring(0, index);
            const val = v.substring(index + 1, v.length);
            obj[name] = val;
        }
    });
    return obj;
}
export function getQueryValue(str, key) {
    if (str) {
        const value = qs.parse(str);
        if (key) {
            return value[key] ? value[key] : '';
        }
        return value;
    }
    return '';
}
export function linkToH5(url) {
    const splitUrl = url.split('?');
    let data = {};
    if (splitUrl.length === 2) {
        data = qs.parse(splitUrl[1]);
        if (data.needToken) {
            data.token = getSStorage('token');
            delete data.needToken;
        }
    }
    return `${splitUrl[0]}?${qs.stringify(data)}`;
}
export function wechatEnv() {
    // 只有在微信小程序下才会引入成功 micromessenger
    console.log('navigator.userAgent', navigator.userAgent);
    if (navigator.userAgent.toLocaleLowerCase().indexOf('micromessenger') > -1) {
        return true;
    }
    return false;
}

export function ttEnvAndIphone() {
    if (navigator.userAgent.indexOf('ToutiaoMicroApp') > -1 || navigator.userAgent.indexOf('toutiaodevtools') > -1) {
        if (navigator.userAgent.toLowerCase().indexOf('iphone') !== -1) {
            return true;
        }
    }
    return false;
}
export function base64Operation(str, type) {
    if (type === 'encode') {
        return encode(str);
    }
    if (type === 'decode') {
        return decode(str);
    }
    return '未指定加密/解密';
}
export function handleDifferentUrlLink(url = '') {
    if (!url) return false;
    const isOutWebUrl = /^http(s)?:\/\//.test(url);
    const isAtourSchema = /^atourlife:\/\//.test(url);
    if (isOutWebUrl) {
        window.location.href = url;
    } else if (isAtourSchema) {
        judgeMiniApp().then(({ type, body }) => {
            if (type === 'wechat' || type === 'alipay') {
                const urlSplitStr = url.split('?');
                const param = getQueryValue(urlSplitStr[1], 'param');
                // 跳转外部小程序的路径
                if (urlSplitStr[0].indexOf('page/launchMiniApp') !== -1) {
                    // 解析参数
                    const {
                        appId,
                        path = '/pages/index/index',
                    } = JSON.parse(base64Operation(param, 'decode'));
                    console.log('base', path, appId);
                    if (type === 'wechat') {
                        body.miniProgram.navigateTo({
                            url: `/pages/h5JumpOtherApp/h5JumpOtherApp?path=${encodeURIComponent(path)}&appId=${appId}`,
                        });
                    } else {
                        body.navigateTo({
                            url: `/pages/h5JumpOtherApp/h5JumpOtherApp?path=${encodeURIComponent(path)}&appId=${appId}`,
                        });
                    }
                }
            } else {
                this.$toast('此链接只在亚朵ATOUR小程序或者APP中有效');
            }
        }).catch(env => {
            if (env === 'app') {
                if (isAtourSchema) {
                    if (isIos()) {
                        pushIframe(url, 1);
                    } else {
                        console.log(url);
                        push(PAGE.JUMP_TO_PAGE, {
                            page: 'webview',
                            data: {
                                url,
                            },
                        });
                    }
                } else {
                    window.location.href = url;
                }
            } else {
                this.$toast('此链接只在亚朵ATOUR小程序或者APP中有效');
            }
        });
    }
    return true;
}
export function appJumpHotelList(params) {
    const version = isIos() ? '3.21.0' : '3.18.0';
    const page = isHighAppVersion(version) ? PAGE.JUMP_TO_NEW_HOTELLIST : PAGE.JUMP_TO_HOTELLIST;
    isIos() ? pure(page, params, () => {}) : push(page, params, () => {});
}

function fillZero(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

export function getCountdown(time) {
    const now = new Date();
    const endDate = new Date(time);
    let leftTime = endDate.getTime() - now.getTime();// 计算剩余的毫秒数
    if (leftTime <= 0) {
        leftTime = 0;
    }
    const leftsecond = leftTime / 1000;// 计算剩余的秒数
    const day = Math.floor(leftsecond / (60 * 60 * 24));
    const hour = Math.floor((leftsecond - day * 24 * 60 * 60) / 3600);
    const minute = Math.floor((leftsecond - day * 24 * 60 * 60 - hour * 3600) / 60);
    const second = Math.floor(leftTime / 1000 % 60);
    return {
        day: fillZero(day),
        hour: fillZero(hour),
        minute: fillZero(minute),
        second: fillZero(second),
    };
}

// 替换url参数
export function replaceUrlParam(url, paramName, paramValue) {
    if (!url || !paramName) return url;
    // 使用正则表达式进行全局替换
    var regExp = new RegExp(paramName + '=([^&]*)');
    if (regExp.test(url)) {
        url = url.replace(regExp, paramName + '=' + paramValue);
    } else {
        url += (url.indexOf('?') === -1 ? '?' : '&') + paramName + '=' + paramValue;
    }
    return url;
}

export function getHeaderInfo() {
    return {
        'At-Platform-Type': getSStorage('platType'),
        'At-Channel-Id': 300001,
        'At-Access-Token': Store.state.token || getSStorage('token') || getLStorage('token'),
        'At-App-Version': getAppVer(),
        'At-Client-Id': guid(),
    };
}

// 替换token，'localStorage'、'sessionStorage'都替换
export function replaceToken(value) {
    setLStorage('token', value);
    setSStorage('token', value);

    setLStorage('iSetToken', value);
    setSStorage('iSetToken', value);

    setLStorage('setToken', value);
    setSStorage('setToken', value);
}

// 公用Ajax请求方法
export function apiRequest(methods, url, data, options = {}) {
    // 是否展示loading以及弹窗
    const hideLoading = options.hideLoading || false;
    const hideToast = options.hideToast || false;
    let loadingObj;
    let timers;
    // 是否展示loading
    if (!hideLoading) {
        timers = setTimeout(() => {
            // 接口很快返回，不弹出加载中
            loadingObj = Toast({
                iconClass: 'icon iconfont-v4 icon-atour',
                duration: CONFIG.apiTimeout,
            });
        }, 500);
    }
    console.log('new promise');
    return new Promise((resolve, reject) => {
        ajax(methods, url, data, options).then(res => {
            if (!hideLoading) {
                if (loadingObj) {
                    loadingObj.close();
                } else {
                    clearTimeout(timers);
                }
            }
            if (+res.retcode === 0 || (res.code === 200 && res.success === true)) {
                resolve(res);
            } else {
                reject(res); // retcode = 10002 登录状态失效，不强制跳转登录页
                if (+res?.retcode !== 10002) { // '非登录状态失效'情况，页面调用时弹出接口异常信息
                    if (!hideToast && res?.retmsg) {
                        Toast({
                            message: res.retmsg,
                            iconClass: 'icon icon-error',
                            duration: 2000,
                        });
                    }
                }
            }
        }).catch(() => {
            // 接口请求不通时走catch
            reject('接口请求错误');
            console.log('ajax error');
            if (loadingObj) {
                loadingObj.close();
            } else {
                clearTimeout(timers);
            }
        });
    });
}

// RSA非对称加密
export async function encrypt(word) {
    return new Promise((resolve, reject) => {
        apiRequest('get', '/verifyCode/getVerifyCodePublicKey', {}).then(res => {
            if (res?.result) {
                try {
                    word = JSON.stringify(word);
                    const key = res.result; // 接口获取key
                    const crypt = new JSEncrypt();
                    crypt.setPublicKey(key);
                    resolve(crypt.encrypt(word));
                } catch (error) {
                    console.log(error);
                    resolve('');
                }
            } else {
                Toast(res?.retmsg || '接口请求错误');
                reject(new Error(res?.retmsg));
            }
        }).catch(err => {
            Toast(err?.retmsg || '接口请求错误');
            reject(new Error(err?.retmsg));
        });
    });
}

// base64转file
export function base64toFile(dataurl, filename = 'weixin') {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

// 返回首页
export function goToIndex() {
    judgeMiniApp().then(({ body, type }) => {
        console.log('是小程序');
        if (type === 'alipay') {
            body.switchTab({
                url: '/pages/index/index',
            });
        } else {
            body.miniProgram.switchTab({
                url: '/pages/index/index',
            });
        }
    }).catch((env) => {
        // 在app中
        if (env === 'app') {
            push(PAGE.JUMP_TO_PAGE, {
                page: 'index',
            });
        } else {
            window.location.href = '/atour';
        }
    });
}

/**
 * 向小程序发送消息
 * @param {Object} body - 小程序实例对象
 * @param {'wechat' | 'tt' | 'alipay'} type - 小程序类型
 * @param {string} postMsgType - 消息类型
 * @param {Object} data - 要发送的数据
 * @returns {Promise<void>}
 */
export const sendPostMessage = async(body, type, postMsgType, data = {}) => {
    if (!body || !type || !postMsgType) {
        throw new Error('入参错误');
    }
    // 验证小程序类型
    const validTypes = ['wechat', 'tt', 'alipay'];
    if (!validTypes.includes(type)) {
        throw new Error('小程序类型错误');
    }

    try {
        const messageData = {
            ...data,
            type: postMsgType,
        };

        const postMessageHandlers = {
            wechat: () => body.miniProgram.postMessage({ data: messageData }),
            tt: () => body.miniProgram.postMessage({ data: messageData }),
            alipay: () => body.postMessage({ data: messageData }),
        };

        await postMessageHandlers[type]();

        return Promise.resolve();
    } catch (error) {
        console.error('error----', error);
        return Promise.reject(error);
    }
};

export default {};
